import config from "../config";

// Public reads of the collections API (DynamoDB-backed, no KVS). The list is
// lightweight (name, description, count); a single collection carries its image
// numbers, fetched only when the visitor opens it.
const CollectionModel = {
  fetchCollections: async () => {
    const res = await fetch(config.collectionsApiUrl);
    if (!res.ok) throw new Error(`Collections request failed (${res.status})`);
    const data = await res.json();
    return Array.isArray(data.collections) ? data.collections : [];
  },

  fetchCollection: async (id) => {
    const res = await fetch(`${config.collectionsApiUrl}/${encodeURIComponent(id)}`);
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`Collection request failed (${res.status})`);
    const data = await res.json();
    return data.collection || null;
  },
};

export default CollectionModel;
